import React from "react";
import CmsLegalPage from "./CmsLegalPage";

export default function Refund() {
    return <CmsLegalPage page="legal_refund" fallbackTitle="Refund & Cancellation Policy" fallbackUpdated="23 February 2026" />;
}
